/**
 * PostMessage bridge for communication with embedded map iframe
 */

export type MapMessage =
  | { type: "FOCUS_ROOM"; room: string }
  | { type: "ROUTE_TO_ROOM"; room: string }
  | { type: "SET_SEARCH"; room: string }
  | { type: "RESET_VIEW" };

export type MapResponse =
  | { type: "ROOM_FOCUSED"; room: string }
  | { type: "ROUTE_STARTED"; room: string }
  | { type: "ERROR"; message: string };

/**
 * Send message to map iframe
 */
export function postToMap(iframe: HTMLIFrameElement | null, message: MapMessage): void {
  const win = iframe?.contentWindow;
  if (!win) {
    console.warn("Map iframe not available");
    return;
  }
  win.postMessage(message, "*");
}

/**
 * Listen for messages from map iframe
 */
export function listenToMap(
  callback: (response: MapResponse) => void
): () => void {
  const handler = (event: MessageEvent) => {
    // Verify origin if needed
    // if (event.origin !== expectedOrigin) return;
    
    if (event.data && typeof event.data === "object" && "type" in event.data) {
      callback(event.data as MapResponse);
    }
  };

  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}
